<template>
  <div class="login-wrapper">
    <v-btn
      class="login-button"
      @click="goToOktaLogin()"
    >
      Login with Okta
    </v-btn>
    <div
      v-if="isLoading"
      class="loading"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    loggedIn() {
      return this.isAuthorized;
    },
  },
  mounted() {
    if (this.loggedIn) {
      this.$router.push('/');
    }
  },
  methods: {
    goToOktaLogin() {
      this.isLoading = true;
      const params = {
        client_id: process.env.VUE_APP_HACKATHON_OKTA_CLIENT_ID,
        response_type: 'code',
        scope: 'openid%20profile%20email%20offline_access',
        redirect_uri: process.env.VUE_APP_HACKATHON_REDIRECT_URI,
        state: 'hackathon-login',
      };
      let loginUrl = process.env.VUE_APP_HACKATHON_OKTA_URI;
      Object.keys(params).forEach((param, index) => {
        const queryOperator = index === 0 ? '?' : '&';
        loginUrl = `${loginUrl}${queryOperator}${param}=${params[param]}`;
      });
      window.location.href = loginUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  display: block;
  position: relative;
  margin-top: 1em;
}

.login-wrapper {
  text-align: center;
}

.login-button {
  margin: 0 auto;
  color: #fff !important;
  background-color: #004e7d !important;
}
</style>
